import React from "react";
import { useTranslation } from "react-i18next";

export interface AlertDialogProps {
    isOpen: boolean;
    title: string;
    description: React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
}

const AlertDialog: React.FC<AlertDialogProps> = ({
    isOpen,
    title,
    description,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
}) => {
    const { t } = useTranslation("common");

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md mx-4 shadow-xl">
                <div className="mb-4">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        {title}
                    </h2>
                    <div className="text-sm text-gray-600 dark:text-gray-300 whitespace-pre-line">
                        {description}
                    </div>
                </div>

                <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                    >
                        {cancelText || t("cancel", "Отмена")}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                    >
                        {confirmText || t("confirm", "Подтвердить")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlertDialog;
